import { config } from '../config';

/** Decode a JWT's `exp` (seconds) into ms-since-epoch. Returns null if unparseable. */
export function decodeJwtExp(token: string | null): number | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const payload = JSON.parse(
      atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')),
    ) as { exp?: number };
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

/**
 * True when the token exists and its expiry is beyond now + buffer.
 * No signature verification — server is the source of truth; this only decides
 * whether to attempt a request vs. show the unlock/refresh path.
 */
export function isAccessTokenValid(
  token: string | null,
  bufferMs: number = config.auth.refreshBuffer,
): boolean {
  const expMs = decodeJwtExp(token);
  if (expMs == null) return false;
  return expMs > Date.now() + bufferMs;
}
